import { render, staticRenderFns } from "./AllCustomers.vue?vue&type=template&id=5b29b9e0&"
import script from "./AllCustomers.vue?vue&type=script&lang=js&"
export * from "./AllCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports